import { DataTable } from "@/components/MDXComponents/DataTable/DataTable";
import { INTEGRATION_ENVIRONMENTS } from "@/data/integrationEnvironments";

const HEADERS = ["Environment", "API base", "OAuth authorize (browser redirect)", "OAuth token"];

const ROWS = [
  { label: "US Sandbox", key: "sandbox_us" as const },
  { label: "Canada Sandbox", key: "sandbox_ca" as const },
  { label: "US Production", key: "production_us" as const },
  { label: "Canada Production", key: "production_ca" as const },
].map(({ label, key }) => {
  const env = INTEGRATION_ENVIRONMENTS[key];
  return [label, env.api_base, env.oauth_authorize, env.oauth_token];
});

export const IntegrationEnvironmentsTable = () => <DataTable headers={HEADERS} rows={ROWS} />;
